<script>
    import { EntryButton } from "@axel669/zephyr"
    import CustomDialog from "./dialog/custom.svelte"
</script>

<EntryButton component={CustomDialog}>
    Open Custom Dialog
</EntryButton>
